import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1386.66667,1333 L1493.33333,1333 L1493.33333,1013 L1386.66667,1013 L1386.66667,1333 Z M1386.66667,1546.33333 L1493.33333,1546.33333 L1493.33333,1439.66667 L1386.66667,1439.66667 L1386.66667,1546.33333 Z M1066.66667,373 L1066.66667,799.666667 L320,799.666667 L320,373 L1066.66667,373 Z M960,479.666667 L426.666667,479.666667 L426.666667,693 L960,693 L960,479.666667 Z M320,1119.66667 L853.333333,1119.66667 L853.333333,1013 L320,1013 L320,1119.66667 Z M320,1333 L640,1333 L640,1226.33333 L320,1226.33333 L320,1333 Z M1.51461294e-28,52.9893333 L1.51461294e-28,1866.32267 L1066.66667,1866.32267 L1066.66667,1759.656 L106.666667,1759.656 L106.666667,159.656 L1280,159.656 L1280,692.989333 L1386.66667,692.989333 L1386.66667,52.9893333 L1.51461294e-28,52.9893333 Z M1440,1653 C1645.86667,1653 1813.33333,1485.53333 1813.33333,1279.66667 C1813.33333,1073.8 1645.86667,906.333333 1440,906.333333 C1234.13333,906.333333 1066.66667,1073.8 1066.66667,1279.66667 C1066.66667,1485.53333 1234.13333,1653 1440,1653 Z M1440,799.666667 C1704.64,799.666667 1920,1015.02667 1920,1279.66667 C1920,1544.30667 1704.64,1759.66667 1440,1759.66667 C1175.36,1759.66667 960,1544.30667 960,1279.66667 C960,1015.02667 1175.36,799.666667 1440,799.666667 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNotGradedLine = /*#__PURE__*/function (_Component) {
  _inherits(IconNotGradedLine, _Component);

  var _super = _createSuper(IconNotGradedLine);

  function IconNotGradedLine() {
    _classCallCheck(this, IconNotGradedLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconNotGradedLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNotGraded",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconNotGradedLine.displayName = "IconNotGradedLine";
  return IconNotGradedLine;
}(Component);

IconNotGradedLine.glyphName = 'not-graded';
IconNotGradedLine.variant = 'Line';
IconNotGradedLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNotGradedLine;
export { IconNotGradedLine };